import React from "react";
import Hero from "@/components/Hero";
import FAQ from "@/components/FAQ";
import Marquee from "@/components/Marquee";
import BookingCTA from "@/components/BookingCTA";
import {
    Manifesto,
    EditorialSplit,
    BenefitsGrid,
    DualCallout,
    RelatedLinks,
} from "@/components/Editorial";
import { HERO_IMG, PHOTO } from "@/data/site";

export default function NailArt() {
    return (
        <>
            <Hero
                eyebrow="Decorazioni eleganti per unghie curate"
                title={["Nail Art", "a Livorno."]}
                subtitle="Piccoli dettagli, colori e decorazioni personalizzate per rendere le tue unghie ancora più curate, eleganti e adatte al tuo stile."
                subtitleMobile="Decorazioni eleganti, sempre curate."
                imgDesktop={HERO_IMG.nailart.d}
                imgMobile={HERO_IMG.nailart.m}
                primaryCta={{ label: "Prenota un appuntamento", href: "/contatti" }}
                secondaryCta={{ label: "Richiedi informazioni", href: "/contatti" }}
            />

            <div className="bg-ivory pt-8 pb-4"></div>

            <Manifesto
                number="01"
                eyebrow="La semplicità"
                title="Quando la semplicità fa la differenza."
                body={[
                    "La Nail Art è un modo per personalizzare le unghie attraverso piccoli dettagli che esprimono gusto, stile e personalità.",
                    "Non è necessario scegliere decorazioni elaborate per ottenere un risultato elegante. Spesso sono proprio i particolari più semplici a valorizzare una manicure.",
                    "Da Spazio Isa realizziamo Nail Art dallo stile essenziale ed elegante, pensate per chi desidera mani sempre curate senza rinunciare alla naturalezza.",
                ]}
            />

            <EditorialSplit
                number="02"
                eyebrow="Le mani in primo piano"
                title="Piccoli dettagli che valorizzano le tue mani."
                image={PHOTO.mani}
                imageAlt="Cura delle mani"
                accentBg="bg-blush/40"
                body={[
                    "Le mani sono sempre in primo piano. Accompagnano ogni gesto, raccontano il nostro stile e trasmettono cura e attenzione verso sé stesse.",
                    "Una linea sottile, un punto luce, un delicato effetto glitter oppure una french rivisitata possono trasformare l'aspetto delle unghie mantenendo uno stile sobrio e raffinato.",
                    "Ogni proposta viene personalizzata: ascoltiamo le preferenze e realizziamo decorazioni che valorizzano la manicure senza appesantirla.",
                ]}
            />

            <BenefitsGrid
                eyebrow="Le nostre proposte"
                title="Decorazioni raffinate, sempre attuali."
                subtitle="Ogni manicure può essere personalizzata con dettagli semplici, eleganti e sempre attuali."
                items={[
                    {
                        title: "French rivisitata",
                        body: "Oltre alla versione classica, è possibile personalizzarla con linee più sottili, colori delicati o piccoli dettagli che la rendono moderna mantenendo la sua eleganza.",
                    },
                    {
                        title: "Glitter e punti luce",
                        body: "Per chi desidera un tocco di luminosità, piccoli glitter o dettagli brillanti possono impreziosire la manicure con discrezione.",
                    },
                    {
                        title: "Decorazioni semplici ed eleganti",
                        body: "Linee sottili, piccoli motivi geometrici, dettagli floreali delicati o elementi minimal. Un risultato armonioso che accompagna la manicure senza diventare il centro dell'attenzione.",
                    },
                    {
                        title: "Colori stagionali e tendenze",
                        body: "Seguiamo le tendenze con equilibrio, proponendo Nail Art che rimangano eleganti anche nel tempo, con tonalità luminose in primavera-estate e più calde in autunno-inverno.",
                    },
                    {
                        title: "Adatte a ogni occasione",
                        body: "Il risultato è una Nail Art che si adatta con naturalezza alla vita quotidiana, al lavoro, alle cerimonie o agli eventi speciali.",
                    },
                    {
                        title: "Pensate per il tuo stile",
                        body: "Ascoltiamo le tue preferenze e realizziamo decorazioni che rispecchiano davvero la tua personalità.",
                    },
                ]}
            />

            <DualCallout
                eyebrow="La scelta giusta"
                title="La Nail Art è la scelta giusta per te?"
                subtitle="Che tu preferisca uno stile classico o un piccolo tocco di originalità, possiamo realizzare decorazioni che valorizzano le tue unghie."
                cards={[
                    {
                        title: "È perfetta se…",
                        list: [
                            "vuoi rendere la tua manicure più personale;",
                            "cerchi dettagli eleganti alle unghie;",
                            "desideri decorazioni semplici e raffinate;",
                            "vuoi mani curate in ogni occasione;",
                            "cerchi uno stile discreto ma moderno;",
                            "vuoi valorizzare le unghie senza effetti eccessivi.",
                        ],
                    },
                    {
                        title: "Ogni Nail Art nasce dalle tue idee",
                        body: "Ascoltiamo le tue preferenze, ti consigliamo le combinazioni più armoniose e realizziamo decorazioni che rispecchiano davvero la tua personalità. Un risultato elegante, curato e mai eccessivo.",
                    },
                ]}
            />

            <EditorialSplit
                number="03"
                eyebrow="Perché Spazio Isa"
                title="Piccoli dettagli, cura infinita."
                image={PHOTO.curaMani}
                imageAlt="Nail Art Spazio Isa"
                accentBg="bg-rose-powder/40"
                body={[
                    "Da oltre 15 anni Spazio Isa accoglie le proprie clienti con professionalità, attenzione ai dettagli e passione per il mondo dell'estetica.",
                    "Ogni manicure viene eseguita con precisione, rispettando la forma naturale delle unghie e proponendo decorazioni armoniose e sempre curate.",
                    "Non realizziamo Nail Art estreme o particolarmente elaborate. Preferiamo valorizzare le mani attraverso piccoli dettagli, colori scelti con gusto e finiture eleganti.",
                ]}
            />

            <BookingCTA
                title="Prenota la tua Nail Art."
                subtitle="Insieme sceglieremo colori, decorazioni e finiture che valorizzino il tuo stile e rendano le tue unghie ancora più belle."
            />

            <FAQ
                items={[
                    {
                        q: "Che tipo di Nail Art realizzate?",
                        a: "Nail Art semplici, eleganti e personalizzate, pensate per valorizzare la manicure con dettagli raffinati e adatti alla vita di tutti i giorni.",
                    },
                    {
                        q: "Posso scegliere la decorazione che preferisco?",
                        a: "Sì. Ogni Nail Art viene personalizzata in base ai gusti della cliente. Durante l'appuntamento potrai scegliere colori, dettagli e stile.",
                    },
                    {
                        q: "Realizzate anche Nail Art elaborate?",
                        a: "Il nostro stile è orientato a decorazioni eleganti e sobrie. Prediligiamo Nail Art raffinate, facilmente indossabili e adatte a ogni occasione.",
                    },
                    {
                        q: "Può essere realizzata su ricostruzione?",
                        a: "Sì. Le decorazioni possono essere eseguite su diversi tipi di manicure, valutando insieme la soluzione più adatta.",
                    },
                    {
                        q: "Quanto dura una Nail Art?",
                        a: "La durata dipende dal trattamento scelto, dalla crescita naturale dell'unghia e dalle abitudini quotidiane della cliente.",
                    },
                    {
                        q: "Posso farla per un'occasione speciale?",
                        a: "Certamente. Molte clienti scelgono una Nail Art personalizzata per cerimonie, matrimoni, feste o altri eventi importanti.",
                    },
                    {
                        q: "Dove si trova Spazio Isa?",
                        a: "In Via A. Minghi 30, nel quartiere Coteto, a Livorno.",
                    },
                ]}
            />

            <RelatedLinks
                items={[
                    { label: "Estetica", to: "/estetica" },
                    { label: "Gelinium", to: "/gelinium" },
                    { label: "Prodotti", to: "/prodotti" },
                    { label: "Contatti", to: "/contatti" },
                ]}
            />
        </>
    );
}
